import { ErrorMessageStrategy } from '@shared/utils/interfaces';

export const criticalScopesChangeStrategy: ErrorMessageStrategy = () => {
  return {
    translationKey: 'errors.CRITICAL_SCOPE_CHANGE',
  };
};
